import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { ENTITY } from '../constant';

const apiEndPoint = constants.ADMIN_URL;

export const doSoftwareSubmoduleCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.SUBMODULE}`, data)
  .then((response) => response)
  .catch((error) => error.response.data);

export const doSoftwareSubmoduleUpdate = (Id, data) => {
  const endPointUri = constants.API.SUBMODULE_BY_ID.replace(ENTITY.SUBMODULE_ID, Id);
  return httpservice()
    .put(endPointUri, data)
    .then((response) => response)
    .catch((error) => error.response.data);
};

export const doSoftwareSubmoduleDelete = (Id) => {
  const endPointUri = constants.API.SUBMODULE_BY_ID.replace(ENTITY.SUBMODULE_ID, Id);
  return httpservice()
    .delete(endPointUri)
    .then((response) => response)
    .catch((error) => error.response.data);
};

export const makeDefault = async (id, isDefault) => {
  let endPointUri = constants.API.SUBMODULE_DEFAULT.replace(ENTITY.SUBMODULE_ID, id);
  endPointUri = endPointUri.replace(ENTITY.IS_DEFAULT, isDefault);
  return httpservice()
    .put(endPointUri, {})
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const updateSoftwareSubmodulePermission = async (id, clientId, softwareId, status) => httpservice()
  .put(
    `${constants.API.CLIENT_SOFTWARE_SUBMODULE_PERMISSION}/${id}`,
    { status, softwareId, clientId },
  ).then((response) => response.data).catch((error) => (error.response && error.response.data ? error.response.data : error));
